/* global axios */
import ApiClient from '../ApiClient';

class CaptainTrainingUrl extends ApiClient {
  constructor() {
    super('captain/training_urls', { accountScoped: true });
  }

  get({ assistantId } = {}) {
    return axios.get(this.url, {
      params: { assistant_id: assistantId },
    });
  }
}

export default new CaptainTrainingUrl();
